import React from 'react';
import Head from 'next/head';
import { ButtonLink } from '../components/ButtonLink.jsx';
import { GlobalPage } from '../components/GlobalPage.jsx';
import { ThreeSteps } from '../components/ThreeSteps.jsx';
import { Container, Layout } from '../components/layout/';
import { BoliglaanPartial } from '../components/BoliglaanPartial.jsx';
import { FrontPageJumbotron } from '../components/FrontPageJumbotron.jsx';
import { UsefulLinksPartial } from '../components/UsefulLinksPartial.jsx';
import { PersonalLoanPartial } from '../components/PersonalLoanPartial.jsx';
import { ThreeMoreBoxesPartial } from '../components/ThreeMoreBoxesPartial.jsx';

export default function IndexPage() {
  return (
    <GlobalPage
      title="Penger.no gir deg verktøyene du trenger for å spare penger"
      description="Test ditt eget boliglån og se om andre banker kan gi deg billigere lån. Vi sammenligner din rente og ditt lån mot andre lån i samme bank."
      canonical="/"
    >
      <Layout>
        <FrontPageJumbotron>
          <h1>Betaler du for mye for lånet ditt?</h1>
          <p>
            Ta testen og se om banken din gir andre bedre rente enn deg, eller
            om naboen din har funnet en bedre og billigere bank enn du har. Det
            kan være store summer å spare!
          </p>
          <p className="buttonLinkContainer">
            <ButtonLink href="/boliglan">
              Test ditt boliglån
              <svg
                className="arrow"
                width="325"
                height="460"
                viewBox="0 0 325 460"
                xmlns="http://www.w3.org/2000/svg"
                role="presentation"
              >
                <g fill="none" stroke="#f4f5fa" strokeWidth="3">
                  <path d="M3 393.2L212.1 98.7l-42.6-12.9 135-82.7-33.8 146.5-24.4-39.1L1.9 452.2zM305.9 1.3L323 11.4 292.5 154l-21-2" />
                  <path d="M252.7 120.8l-11.9 16.5-225.7 321-14.5-2.8" />
                </g>
              </svg>
            </ButtonLink>
            <ButtonLink href="/forbrukslan">
              Test ditt forbruks&shy;lån
            </ButtonLink>
          </p>
        </FrontPageJumbotron>
        <Container>
          <ThreeSteps
            steps={[
              {
                title: 'Fortell oss din rente',
                paragraph: `Fyll ut et kort og enkelt skjema om ditt boliglån.
                          Det er alt vi trenger å vite for å si om du betaler
                          for mye for boliglånet ditt.`,
              },
              {
                title: 'Se sammenligning',
                paragraph: `Vi sammenligner din rente og ditt lån mot andre lån i
                          samme bank, og på samme sted.`,
              },
              {
                title: 'Spar penger',
                paragraph: `Få argumentene du må gi banken for å oppnå bedre
                          rente, eller få tilbud fra nye banker.`,
              },
            ]}
          />
          <BoliglaanPartial />
          <ThreeMoreBoxesPartial />
          <PersonalLoanPartial />
          <UsefulLinksPartial />
        </Container>
      </Layout>
      <style jsx>{`
        p.buttonLinkContainer {
          text-align: right;
          background-color: transparent;
        }

        .arrow {
          position: absolute;
          top: 100%;
          left: -100%;
          width: 280px;
          height: auto;
          pointer-events: none;
        }

        .buttonLinkContainer :global(a + a) {
          margin-top: 18px;
        }

        @media screen and (min-width: 750px) {
          p.buttonLinkContainer {
            text-align: left;
            max-width: 620px;
          }

          .arrow {
            left: -50%;
            width: 325px;
            z-index: 1;
          }

          .buttonLinkContainer :global(a + a) {
            margin-top: 0;
            margin-left: 18px;
          }
        }
      `}</style>
      <style jsx global>{`
        body {
          overflow-x: hidden;
        }
      `}</style>
    </GlobalPage>
  );
}
